import { useMalware } from "../../../context/Dashboard/contextMalware";
import { useThemeMode } from "../../../context/contextTheme";
import { useMemo } from "react";

const UrlForm = () => {
  const { theme } = useThemeMode();
  const { handleUrlScan, url, setUrl, malScanLoading } = useMalware();

  return (
    <div className="fade-in">
      <div
        className="rounded-4 p-4"
        style={{
          backgroundColor: theme.cardBg ?? theme.background,
          border: `1px dashed ${theme.border}`,
          height: 280,
        }}
      >
        <div className="d-flex justify-content-center mb-3">
          <i className="bi bi-link-45deg" style={{ fontSize: "3.5rem", color: theme.textMuted }} />
        </div>

        <div className="d-flex justify-content-center">
          <div className="w-100" style={{ maxWidth: 520 }}>
            <div className="input-group">
              <span className="input-group-text" id="url-addon" style={{ background: theme.background, color: theme.textMuted }}>
                URL
              </span>
              <input
                type="text"
                className="form-control text-start"
                aria-describedby="url-addon"
                placeholder="https://example.com/suspicious"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                style={{ background: theme.background, color: theme.textColor, borderColor: theme.border }}
                onKeyDown={(e) => (e.key === "Enter" ? handleUrlScan() : null)}
              />
              <button
                className="btn fw-semibold"
                style={{
                  minWidth: 140,
                  color: theme.textColorInv,
                  backgroundColor: theme.secondary,
                }}
                onClick={handleUrlScan}
                disabled={malScanLoading}
              >
                {malScanLoading ? "Submitting…" : "Submit URL"}
              </button>
            </div>
            <div className="form-text text-center mt-2" style={{ color: theme.textMuted }}>
              We’ll query VirusTotal reputations and behavior for the provided URL.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UrlForm;